module.exports = __webpack_public_path__ + "img/slim_cleanstation00.c150ec33.jpg";